export interface IImprint {
  address: { street: string; zipCode: string; city: string; country: string };
  authorizedExecutive: string;
  company: {
    name: string;
    id: string;
    districtCourt: string;
  };
  email: { contact: string; support: string };
  responsiblePerson: string;
  telephone: string;
  telefax: string;
}

export const imprint: IImprint = {
  address: { street: 'Friedenstrasse 24', zipCode: '81671', city: 'München', country: 'Germany' },
  authorizedExecutive: 'Nastuh Abootalebi, Kieve Ducharme, Alexander Nagel, Holger Scharnofske, Marc Schnitzler, Timo Wolf',
  company: {
    name: 'Serviceplan Make GmbH & Co. KG',
    id: 'DE 219748758',
    districtCourt: 'Munich HRA 78924',
  },
  email: { contact: 'info(at)house-of-communication.com', support: 'serviceplanmakeos(at)house-of-communication.com' },
  responsiblePerson: 'Nastuh Abootalebi',
  telephone: '+49 89 2050 4300',
  telefax: '+49 89 2050 60 4300',
};
